/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, OnInit, signal} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './creative-retail-product-modal.component.html';
import {deferSignalViewWrite} from '../common/util/template-state';

@Component({
  standalone: false,
  selector: 'adn-creative-retail-product-modal',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreativeRetailProductModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  selRetailProduct: any;
  onSelect: (product: any) => Promise<any> | any;

  createHook: (product: any) => void;
  disabled = false;
  readonly viewRevision = signal(0);

  constructor(public bsModalRef: BsModalRef) {
  }

  ngOnInit(): void {
    this.createHook = (product: any) => {
      if (!_.isFunction(this.onSelect) || this.disabled) {
        return;
      }
      this.disabled = true;
      Promise.resolve(this.onSelect(product)).then(() => {
        this.bsModalRef.hide();
      }).catch(() => undefined).finally(() => {
        // Avoid NG0100 on [class.disabled] when select settles in the same CD turn.
        deferSignalViewWrite(this.viewRevision, () => {
          this.disabled = false;
        });
      });
    };
  }

  dismiss(): void {
    if (!this.disabled) {
      this.bsModalRef.hide();
    }
  }
}
